import api from "./api";

// Fetch notifications
export const fetchNotifications =
    async (
        filterField,
        filterValue,
        page = 1,
        size = 10
    ) => {
        try {
            const params = {
                page,
                size,
            };

            if (
                filterField &&
                filterValue
            ) {
                params.filter_field =
                    filterField;

                params.filter_value =
                    filterValue;
            }

            const response =
                await api.get(
                    "/notification-management/notifications/me",
                    {
                        params,
                    }
                );

            if (
                response.status ===
                200
            ) {
                const {
                    data,
                } =
                    response.data;

                const {
                    results,
                    total,
                    page:
                        currentPage,
                    size:
                        pageSize,
                } = data;

                return {
                    notifications:
                        results,
                    total,
                    hasMore:
                        currentPage *
                            pageSize <
                        total,
                    page:
                        currentPage,
                };
            }

            return {
                error:
                    "Unexpected response from server",
            };
        } catch (
            error
        ) {
            console.error(
                "Error fetching notifications:",
                error
            );

            return {
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message ||
                    "Failed to fetch notifications",
            };
        }
    };

// Mark notification as read
export const markNotificationAsRead =
    async (
        notificationId
    ) => {
        try {
            const response =
                await api.put(
                    `/notification-management/notifications/${notificationId}/mark-as-read`
                );

            if (
                response.status ===
                200
            ) {
                return response.data;
            }

            return {
                error:
                    "Unexpected response from server",
            };
        } catch (
            error
        ) {
            console.error(
                "Error marking notification as read:",
                error
            );

            return {
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message ||
                    "Failed to mark notification as read",
            };
        }
    };